import React, { useEffect } from 'react';

const BodyAnalysisReportPage = () => {
  useEffect(() => {
    // Load iframe-resizer script
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/iframe-resizer/js/iframeResizer.min.js';
    script.async = true;
    document.body.appendChild(script);

    // Initialize iframe resizer after script loads
    script.onload = () => {
      if (typeof window.iFrameResize === 'function') {
        window.iFrameResize({
          log: false,
          checkOrigin: ["https://forms.itskaivalya.com"],
          heightCalculationMethod: "max"
        }, '#gf-snh');
      }
    };

    // Cleanup script on component unmount
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="pt-16 min-h-screen bg-[#FFFDF8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="bg-[#2E7D32] py-4 px-6">
            <h1 className="text-xl font-bold text-white font-poppins">Body Analysis Report</h1>
          </div>
          <div className="p-4">
            <div className="bg-[#EAF8EC] rounded-lg p-4 mb-4">
              <p className="text-[#205C25] text-sm">
                <span className="font-semibold">Note:</span> Your personalized body analysis report is loading below. 
                This may take a few moments.
              </p>
            </div>
            
            {/* Option A2: iFrame Resizer (recommended) */}
            <iframe
              id="gf-snh"
              src="https://forms.itskaivalya.com/body-analysis-report-sams-nutri-hub-snh-2"
              className="w-full border-0"
              style={{ minHeight: '600px' }}
              scrolling="no"
              loading="lazy"
              referrerPolicy="strict-origin-when-cross-origin"
              allow="payment *; clipboard-write *"
            >
              <p>Your browser does not support iframes. Please visit: 
                <a 
                  href="https://forms.itskaivalya.com/body-analysis-report-sams-nutri-hub-snh-2" 
                  className="text-[#2E7D32] hover:underline"
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  Body Analysis Report Form
                </a>
              </p>
            </iframe>
            
            {/* Alternative Option A1: Minimal iframe embed */}
            <div className="mt-8">
              <h2 className="text-lg font-semibold mb-2">Alternative View:</h2>
              <iframe
                src="https://forms.itskaivalya.com/body-analysis-report-sams-nutri-hub-snh-2"
                className="w-full border-0"
                style={{ minHeight: '900px' }}
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
                allow="payment *; clipboard-write *"
              >
                <p>Your browser does not support iframes. Please visit: 
                  <a 
                    href="https://forms.itskaivalya.com/body-analysis-report-sams-nutri-hub-snh-2" 
                    className="text-[#2E7D32] hover:underline"
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    Body Analysis Report Form
                  </a>
                </p>
              </iframe>
            </div>
            
            {/* Optional: Prefill via query string */}
            <div className="mt-8">
              <h2 className="text-lg font-semibold mb-2">Prefilled Form (Example):</h2>
              <iframe
                src="https://forms.itskaivalya.com/body-analysis-report-sams-nutri-hub-snh-2?name=John%20Doe&email=john%40example.com"
                className="w-full border-0"
                style={{ minHeight: '900px' }}
                loading="lazy"
              >
                <p>Your browser does not support iframes. Please visit: 
                  <a 
                    href="https://forms.itskaivalya.com/body-analysis-report-sams-nutri-hub-snh-2?name=John%20Doe&email=john%40example.com" 
                    className="text-[#2E7D32] hover:underline"
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    Body Analysis Report Form
                  </a>
                </p>
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BodyAnalysisReportPage;